import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UiAppHeaderComponent } from '../../organisms/app-header/app-header.component';
import { UiStepValidationComponent } from '../../organisms/step-validation/step-validation.component';
import { UiStepValidationStep } from '../../organisms/step-validation/step-validation.types';

export const UI_PROVEEDORES_CONSULTA_REGISTRO_STEPS: readonly UiStepValidationStep[] =
  [
    { id: 'general', label: 'Datos generales', status: 'review' },
    {
      id: 'contacts',
      label: 'Contactos y contraseña',
      status: 'observations',
    },
    { id: 'payment', label: 'Datos para pago', status: 'validated' },
    { id: 'documents', label: 'Documentos', status: 'review' },
  ];

/**
 * Template: consulta del registro de proveedores.
 *
 * Compone App Header (`consultation`) y Step Validation.
 * Los estatus de cada paso son En revisión, Con observaciones o Validado.
 */
@Component({
  selector: 'ui-proveedores-consulta-registro',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAppHeaderComponent, UiStepValidationComponent],
  templateUrl: './proveedores-consulta-registro.component.html',
  styleUrl: './proveedores-consulta-registro.component.scss',
})
export class UiProveedoresConsultaRegistroComponent {
  readonly logoSrc = input('/images/logo_azul.png');
  readonly logoAlt = input('Diseño y Gestión Inmobiliaria');
  readonly navTitle = input('Consulta de estatus de registro');

  readonly userAvatarLabel = input<string | null>(null);
  readonly userAvatarAlt = input('Usuario');
  readonly profileUserName = input('Usuario');
  readonly profileUserRole = input('');
  readonly profileUserEmail = input('');

  readonly steps = input<readonly UiStepValidationStep[]>(
    UI_PROVEEDORES_CONSULTA_REGISTRO_STEPS,
  );
  readonly interactive = input(false);
  readonly selectedId = input<string | null>(null);

  readonly stepSelect = output<UiStepValidationStep>();
  readonly notificationClick = output<void>();
  readonly logoutClick = output<void>();
}
